import store from "@/store";
import { resolveActiveRole, routeForRole } from "@/utils/roleAccess";

export const loginGuards = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    return next();
  }
  const access = store.getters.dashboardAccess || [];
  const activeRole = resolveActiveRole(access, store.getters.activeRole);
  const route = activeRole && routeForRole(activeRole);
  return next(route ? route.path : "/");
};

function hasAccess(role) {
  const access = store.getters.dashboardAccess || [];
  return store.getters.isAuthenticated && access.includes(role);
}

function enterAs(role, next) {
  if (store.getters.activeRole !== role) {
    store.commit("setActiveRole", role);
  }
  next();
}

export const adminGuards = (to, from, next) => {
  if (hasAccess("Admin")) return enterAs("Admin", next);
  next("/");
};

export const subAdminGuards = (to, from, next) => {
  if (store.getters.activeRole === "Admin" && hasAccess("Admin")) {
    return enterAs("Admin", next);
  }
  if (hasAccess("Sub Admin")) return enterAs("Sub Admin", next);
  if (hasAccess("Admin")) return enterAs("Admin", next);
  next("/");
};

export const studentGuards = (to, from, next) => {
  const roles = store.getters.roles || [];
  if (store.getters.isAuthenticated && roles.includes("Student")) {
    return next();
  }
  next("/");
};

export const evaluatorGuards = (to, from, next) => {
  if (hasAccess("Evaluator") || hasAccess("Admin")) {
    return enterAs("Evaluator", next);
  }
  next("/");
};

export const proctorGuards = (to, from, next) => {
  if (hasAccess("Proctor")) return enterAs("Proctor", next);
  next("/");
};

export const universityTeamGuards = (to, from, next) => {
  if (hasAccess("University Team")) return enterAs("University Team", next);
  next("/");
};

export const configGuards = (to, from, next) => {
  if (
    store.getters.activeRole === "University Team" &&
    hasAccess("University Team")
  ) {
    return enterAs("University Team", next);
  }
  if (hasAccess("Admin")) return enterAs("Admin", next);
  if (hasAccess("University Team")) return enterAs("University Team", next);
  next("/");
};

export const examinerGuards = (to, from, next) => {
  if (hasAccess("Examiner") || hasAccess("Admin")) {
    return enterAs("Examiner", next);
  }
  next("/");
};

export const examCoordinatorGuards = (to, from, next) => {
  if (hasAccess("Exam Coordinator") || hasAccess("Admin")) {
    return enterAs("Exam Coordinator", next);
  }
  next("/");
};

export const examManagementGuards = (to, from, next) => {
  if (
    store.getters.activeRole === "Exam Coordinator" &&
    hasAccess("Exam Coordinator")
  ) {
    return enterAs("Exam Coordinator", next);
  }
  if (store.getters.activeRole === "Dsm" && hasAccess("Dsm")) {
    return enterAs("Dsm", next);
  }
  if (hasAccess("Admin")) return enterAs("Admin", next);
  if (hasAccess("Exam Coordinator")) return enterAs("Exam Coordinator", next);
  if (hasAccess("Dsm")) return enterAs("Dsm", next);
  next("/");
};

export const examViewGuards = (to, from, next) => {
  const currentRole = store.getters.activeRole;
  if (currentRole === "Exam Coordinator" && hasAccess("Exam Coordinator")) {
    return enterAs("Exam Coordinator", next);
  }
  if (currentRole === "Dsm" && hasAccess("Dsm")) {
    return enterAs("Dsm", next);
  }
  if (hasAccess("Admin")) return enterAs("Admin", next);
  if (hasAccess("Exam Coordinator")) return enterAs("Exam Coordinator", next);
  if (hasAccess("Dsm")) return enterAs("Dsm", next);
  next("/");
};

export const questionBankViewGuards = (to, from, next) => {
  const currentRole = store.getters.activeRole;
  if (currentRole === "Exam Coordinator" && hasAccess("Exam Coordinator")) {
    return enterAs("Exam Coordinator", next);
  }
  if (currentRole === "Dsm" && hasAccess("Dsm")) {
    return enterAs("Dsm", next);
  }
  if (hasAccess("Admin")) return enterAs("Admin", next);
  if (hasAccess("Exam Coordinator")) return enterAs("Exam Coordinator", next);
  if (hasAccess("Dsm")) return enterAs("Dsm", next);
  next("/");
};
